import Overview from '../pages/finance/Overview'
import InvoicesCreditNotes from '../pages/finance/InvoicesCreditNotes'
import PaymentsUnpaid from '../pages/finance/PaymentsUnpaid'
import Quotes from '../pages/finance/Quotes'
import XeroExport from '../pages/finance/XeroExport'
import PTSTariffsBilling from '../pages/finance/PTSTariffsBilling'
import FinanceKPIs from '../pages/finance/FinanceKPIs'

export default [
  {
    id: 'overview',
    title: 'Overview',
    pages: [
      {
        id: 'overview',
        title: 'Finance Overview',
        summary:
          'The Finance Centre dashboard, the combined Event and PTS money ledger, where invoices and quotes come from, and the roles that control access.',
        component: Overview,
        tags: ['Finance', 'Overview', 'Finance Centre', 'Roles'],
      },
    ],
  },
  {
    id: 'invoicing',
    title: 'Invoicing',
    pages: [
      {
        id: 'invoices-and-credit-notes',
        title: 'Invoices and Credit Notes',
        summary:
          'The combined Event and PTS invoice list, the invoice lifecycle from Draft through Approved and Sent to Paid or Overdue, automatic overdue flagging and reminder emails, PDFs, and full or partial credit notes.',
        component: InvoicesCreditNotes,
        tags: [
          'Finance',
          'Invoices',
          'Credit Notes',
          'Lifecycle',
          'Approve',
          'Send',
          'Reissue',
          'VAT',
          'PDF',
          'Overdue',
        ],
      },
      {
        id: 'payments-and-unpaid-invoices',
        title: 'Payments and Unpaid Invoices',
        summary:
          'Recording full and part payments with a payment method, the Mark Paid shortcut, and chasing open event invoices on the Unpaid Invoices page.',
        component: PaymentsUnpaid,
        tags: [
          'Finance',
          'Payments',
          'Part Payment',
          'Payment Method',
          'Mark Paid',
          'Unpaid Invoices',
          'Debtors',
        ],
      },
    ],
  },
  {
    id: 'quoting',
    title: 'Quoting',
    pages: [
      {
        id: 'quotes',
        title: 'Quotes',
        summary:
          'The combined Event and PTS quote list — per-source statuses, pipeline value, automatic expiry, and where quotes are created and worked.',
        component: Quotes,
        tags: ['Finance', 'Quotes', 'Pipeline', 'Proposals'],
      },
    ],
  },
  {
    id: 'exports-and-reporting',
    title: 'Exports and Reporting',
    pages: [
      {
        id: 'xero-export',
        title: 'Exporting Invoices to Xero',
        summary:
          'Exporting selected invoices as a CSV in Xero sales-invoice import format — the columns, credit notes and discounts, nominal code and tax-type settings, and avoiding double imports.',
        component: XeroExport,
        tags: [
          'Finance',
          'Xero',
          'Export',
          'CSV',
          'Accounting',
          'Nominal Code',
          'Tax Type',
        ],
      },
      {
        id: 'pts-tariffs-and-billing',
        title: 'PTS Tariffs and Billing',
        summary:
          'How Patient Transport tariffs, quotes, invoices, and billing runs work and where they meet the Finance area — with links to the full PTS billing guide.',
        component: PTSTariffsBilling,
        tags: [
          'Finance',
          'PTS',
          'Tariffs',
          'Billing Runs',
          'Mileage',
          'Contracts',
        ],
      },
      {
        id: 'finance-kpis',
        title: 'Finance KPIs',
        summary:
          'The Finance section of the KPI dashboard — revenue, event costs and margin, outstanding and overdue balances, expiring quotes, and aged debtors.',
        component: FinanceKPIs,
        tags: [
          'Finance',
          'KPI',
          'Revenue',
          'Margin',
          'Debtors',
          'Aged Debt',
        ],
      },
    ],
  },
]
